var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{class:_vm.listClass,attrs:{"row":"","wrap":""}},_vm._l((_vm.products),function(product){return _c('v-flex',{key:product.id,class:[_vm.itemClass]},[_c('product-thumbnail',{attrs:{"product":product}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }